import React, { useCallback } from 'react';

import { Container } from './styles';

function Labels({ labels, onSelected, labelsChecked }) {
  const isChecked = useCallback(
    (id) => {
      let check = false;
      labelsChecked.forEach((labelId) => {
        if (labelId === id) {
          check = true;
        }
      });
      return check;
    }, [labelsChecked],
  );


  return (
    <Container>
      <p>
        Filtrar por Tags:
      </p>
      {labels.map(tag => (
        <label htmlFor={`check-${tag.id}`} key={tag.id}>
          <input checked={labelsChecked && isChecked(tag.id)} onClick={() => onSelected(tag.id)} id={`check-${tag.id}`} type="checkbox" value={tag.id} />
          <span>
            {tag.name}
          </span>
        </label>
      ))}
    </Container>
  );
}

export default Labels;
